import { Box } from '@chakra-ui/react';

export default function SidebarWrapper({ children }: any) {
    return (
        <Box
            p={{
                base: 0,
                md: 4,
            }}
            marginTop={{
                base: 4,
                md: 0,
            }}
            paddingTop={{
                base: 0,
                md: 0,
            }}
            flex="0 0 auto"
            width={{
                lg: '400px',
            }}
            borderLeftColor="gray.200"
            borderLeftWidth={{
                base: 0,
                md: '1px',
            }}
        >
            {children}
        </Box>
    );
}
